(function () {
  if (!document.body.classList.contains('template-product')) return;

  function formatMoney(cents, format) {
    if (!format) format = '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function parseVariants(section) {
    var el = section.querySelector('[data-variant-json]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getTierRules(root) {
    try {
      return JSON.parse(root.getAttribute('data-tier-rules') || '{}');
    } catch (e) {
      return {};
    }
  }

  function getTierPercents(root, unitPrice) {
    var rules = getTierRules(root);
    var budgetMax = rules.budgetMax || 3400;
    var standardMax = rules.standardMax || 4900;
    var band = rules.premium;

    if (unitPrice <= budgetMax) band = rules.budget;
    else if (unitPrice <= standardMax) band = rules.standard;

    var tier2 = (band && band['2']) || 10;
    var tier3 = (band && band['3']) || 15;

    if (rules.override2 != null) tier2 = rules.override2;
    if (rules.override3 != null) tier3 = rules.override3;

    return { tier2: tier2, tier3: tier3 };
  }

  function applyTierPercents(root, unitPrice) {
    var percents = getTierPercents(root, unitPrice);
    root.querySelectorAll('[data-valor-bundle-tier]').forEach(function (tier) {
      var qty = parseInt(tier.getAttribute('data-qty'), 10);
      if (qty === 2) tier.setAttribute('data-pct', percents.tier2);
      if (qty === 3) tier.setAttribute('data-pct', percents.tier3);
    });
    return percents;
  }

  function calcTierFromPrices(prices, pct) {
    var subtotal = prices.reduce(function (sum, price) { return sum + price; }, 0);
    var discounted = prices.reduce(function (sum, price) {
      return sum + Math.round(price * (100 - pct) / 100);
    }, 0);
    var qty = prices.length;
    var each = qty ? Math.round(discounted / qty) : discounted;
    return { total: discounted, each: each, subtotal: subtotal };
  }

  function calcTier(totalCents, qty, pct) {
    var prices = [];
    var unit = qty ? Math.round(totalCents / qty) : totalCents;
    for (var i = 0; i < qty; i++) prices.push(unit);
    return calcTierFromPrices(prices, pct);
  }

  function getSelectedTierEl(root) {
    return root.querySelector('[data-valor-bundle-tier].is-selected');
  }

  function getSelectedTier(root) {
    var selected = getSelectedTierEl(root);
    if (!selected) return { qty: 1, pct: 0, el: null };
    var qty = parseInt(selected.getAttribute('data-qty'), 10) || 1;
    var pct = parseInt(selected.getAttribute('data-pct'), 10) || 0;
    return { qty: qty, pct: pct, el: selected };
  }

  function getOptionCount(tierEl) {
    if (!tierEl) return 0;
    var firstItem = tierEl.querySelector('[data-bundle-item]');
    if (!firstItem) return 0;
    return firstItem.querySelectorAll('.valor-bundle__select').length;
  }

  function getItemSelections(tierEl, itemIndex) {
    var selections = {};
    if (!tierEl) return selections;
    tierEl.querySelectorAll('.valor-bundle__select[data-bundle-item="' + itemIndex + '"]').forEach(function (sel) {
      var idx = parseInt(sel.getAttribute('data-option-index'), 10);
      selections[idx] = sel.value;
    });
    return selections;
  }

  function findVariant(variants, selections, optionCount) {
    return variants.find(function (v) {
      for (var i = 0; i < optionCount; i++) {
        var key = 'option' + (i + 1);
        if (selections[i] != null && v[key] !== selections[i]) return false;
      }
      return true;
    });
  }

  function variantAvailable(variants, selections, optionCount, optionIndex, value) {
    var test = Object.assign({}, selections);
    test[optionIndex] = value;
    var match = findVariant(variants, test, optionCount);
    return !!(match && match.available);
  }

  function syncSelectAvailability(tierEl, variants, itemIndex) {
    var optionCount = getOptionCount(tierEl);
    var selections = getItemSelections(tierEl, itemIndex);

    tierEl.querySelectorAll('.valor-bundle__select[data-bundle-item="' + itemIndex + '"]').forEach(function (sel) {
      var optionIndex = parseInt(sel.getAttribute('data-option-index'), 10);
      Array.prototype.forEach.call(sel.options, function (opt) {
        var available = variantAvailable(variants, selections, optionCount, optionIndex, opt.value);
        opt.disabled = !available;
      });
      if (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled) {
        for (var i = 0; i < sel.options.length; i++) {
          if (!sel.options[i].disabled) {
            sel.selectedIndex = i;
            break;
          }
        }
      }
    });
  }

  function resolveItemVariant(tierEl, variants, itemIndex) {
    var optionCount = getOptionCount(tierEl);
    var selections = getItemSelections(tierEl, itemIndex);
    var keys = Object.keys(selections);
    if (keys.length < optionCount) {
      return { variant: null, complete: false };
    }
    var variant = findVariant(variants, selections, optionCount);
    return { variant: variant, complete: true };
  }

  function getActiveVariants(root, variants, tier) {
    var list = [];
    for (var i = 1; i <= tier.qty; i++) {
      var resolved = resolveItemVariant(tier.el, variants, i);
      if (!resolved.complete || !resolved.variant || !resolved.variant.available) return null;
      list.push(resolved.variant);
    }
    return list;
  }

  function sumPrices(variantList) {
    return variantList.reduce(function (sum, v) { return sum + v.price; }, 0);
  }

  function updateTierLabels(root, subtotalForCurrentTier, activePrices) {
    var format = root.getAttribute('data-money-format');
    var currentTier = getSelectedTier(root);
    var unitPrice = parseInt(root.getAttribute('data-unit-price'), 10) || 0;
    var avgUnit = currentTier.qty > 0 && subtotalForCurrentTier > 0
      ? Math.round(subtotalForCurrentTier / currentTier.qty)
      : unitPrice;

    root.querySelectorAll('[data-valor-bundle-tier]').forEach(function (tier) {
      var qty = parseInt(tier.getAttribute('data-qty'), 10);
      var pct = parseInt(tier.getAttribute('data-pct'), 10) || 0;
      var prices = [];
      var i;

      if (qty === currentTier.qty && subtotalForCurrentTier > 0 && activePrices && activePrices.length === qty) {
        prices = activePrices.slice();
      } else {
        for (i = 0; i < qty; i++) prices.push(avgUnit);
      }

      var math = calcTierFromPrices(prices, pct);
      var totalEl = tier.querySelector('[data-valor-bundle-tier-total]');
      var eachEl = tier.querySelector('[data-valor-bundle-tier-each]');
      var saveEl = tier.querySelector('[data-valor-bundle-tier-save]');

      if (totalEl) totalEl.textContent = formatMoney(math.total, format);
      if (eachEl) eachEl.textContent = formatMoney(math.each, format) + ' each';
      if (saveEl && pct > 0) saveEl.textContent = 'Save ' + pct + '%';
    });
  }

  function syncMainVariant(form, variant) {
    if (!variant) return;
    var select = form.querySelector('[name="id"]');
    if (select) {
      select.value = variant.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
  }

  function syncAddToCartLabel(root, tier, subtotalCents, activeVariants) {
    var btnText = document.querySelector('[data-add-to-cart-text]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (!btnText) return;

    var format = root.getAttribute('data-money-format');
    var prices = activeVariants && activeVariants.length === tier.qty
      ? activeVariants.map(function (v) { return v.price; })
      : null;
    var math;

    if (prices) {
      math = calcTierFromPrices(prices, tier.pct || 0);
    } else {
      math = calcTier(
        subtotalCents || parseInt(root.getAttribute('data-unit-price'), 10) * tier.qty,
        tier.qty,
        tier.pct || 0
      );
    }

    if (tier.qty === 1) {
      btnText.textContent = 'Add to Bag — ' + formatMoney(math.total, format);
    } else {
      btnText.textContent = 'Add ' + tier.qty + ' to Bag — Save ' + tier.pct + '%';
    }

    if (addBtn) {
      addBtn.disabled = subtotalCents <= 0 && root.getAttribute('data-has-variants') === 'true';
    }
  }

  function toggleTierBodies(root) {
    root.querySelectorAll('[data-valor-bundle-tier]').forEach(function (tier) {
      var body = tier.querySelector('[data-valor-bundle-tier-body]');
      var selected = tier.classList.contains('is-selected');
      if (body) body.hidden = !selected;
    });
  }

  function selectTier(root, tierEl, variants, form, section) {
    root.querySelectorAll('[data-valor-bundle-tier]').forEach(function (btn) {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-checked', 'false');
    });
    tierEl.classList.add('is-selected');
    tierEl.setAttribute('aria-checked', 'true');
    toggleTierBodies(root);
    refresh(root, variants, form, section);
  }

  function buildCartItems(activeVariants, tierQty, tierPct) {
    var bundleKey = 'vb' + Date.now();
    return activeVariants.map(function (v) {
      var discountedUnit = Math.round(v.price * (100 - tierPct) / 100);
      return {
        id: v.id,
        quantity: 1,
        properties: {
          Bundle: tierQty + '-pack offer',
          '_valor_bundle_key': bundleKey,
          '_valor_bundle_pct': String(tierPct),
          '_valor_discounted_unit': String(discountedUnit)
        }
      };
    });
  }

  function addBundleToCart(form, items, addBtn, tierQty, tierPct) {
    if (addBtn) addBtn.classList.add('btn--loading');
    var discountCode = window.valorBundleCart
      ? window.valorBundleCart.buildDiscountCode(tierQty, tierPct)
      : (tierQty >= 2 && tierPct ? 'BUNDLE' + tierQty + 'P' + tierPct : null);

    return fetch(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status === 422) throw data;

        if (!discountCode) {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        }

        var apply = window.valorBundleCart
          ? window.valorBundleCart.applyDiscount(discountCode)
          : fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' });

        return apply.then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        }).then(function (cart) {
          if (cart.total_discount === 0) {
            return apply.then(function () {
              return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
            });
          }
          return cart;
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (window.valorBundleCart) {
          return window.valorBundleCart.updateCartTotalsDisplay();
        }
      })
      .then(function () {
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: items, addToCartBtn: addBtn },
          bubbles: true
        }));
      })
      .catch(function (err) {
        showError((err && err.description) ? err.description : 'Could not add to bag. Check your selections.');
      })
      .finally(function () {
        if (addBtn) addBtn.classList.remove('btn--loading');
      });
  }

  function showError(msg) {
    var root = document.querySelector('[data-valor-bundle]');
    if (!root) return;
    var errorDiv = root.querySelector('.valor-bundle-error');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'valor-bundle-error';
      root.appendChild(errorDiv);
    }
    errorDiv.textContent = msg;
  }

  function clearError(root) {
    var errorDiv = root.querySelector('.valor-bundle-error');
    if (errorDiv) errorDiv.remove();
  }

  function refresh(root, variants, form, section) {
    var tier = getSelectedTier(root);
    if (!tier.el) return;

    for (var i = 1; i <= tier.qty; i++) {
      syncSelectAvailability(tier.el, variants, i);
    }

    var active = getActiveVariants(root, variants, tier);
    var subtotal = active ? sumPrices(active) : 0;

    if (active && active[0]) {
      root.setAttribute('data-unit-price', active[0].price);
      syncMainVariant(form, active[0]);
    }

    applyTierPercents(root, active ? active[0].price : parseInt(root.getAttribute('data-unit-price'), 10));
    updateTierLabels(root, subtotal, active ? active.map(function (v) { return v.price; }) : null);
    syncAddToCartLabel(root, getSelectedTier(root), subtotal, active);
    clearError(root);
  }

  function initBundle(root) {
    var section = root.closest('[data-section-type="product"]');
    if (!section) return;

    var formId = root.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : section.querySelector('.product-single__form');
    if (!form) return;

    var variants = parseVariants(section);
    var defaultTier = parseInt(root.getAttribute('data-default-tier'), 10) || 2;
    var hasVariants = root.getAttribute('data-has-variants') === 'true';

    root.querySelectorAll('[data-valor-bundle-tier-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        var tierEl = head.closest('[data-valor-bundle-tier]');
        if (!tierEl.classList.contains('is-selected')) {
          selectTier(root, tierEl, variants, form, section);
        }
      });
    });

    root.querySelectorAll('.valor-bundle__select').forEach(function (sel) {
      sel.addEventListener('click', function (evt) {
        evt.stopPropagation();
      });
      sel.addEventListener('change', function () {
        refresh(root, variants, form, section);
      });
    });

    toggleTierBodies(root);

    var preset = root.querySelector('[data-valor-bundle-tier][data-qty="' + defaultTier + '"]');
    if (preset && !preset.classList.contains('is-selected')) {
      selectTier(root, preset, variants, form, section);
    } else {
      refresh(root, variants, form, section);
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var tier = getSelectedTier(root);
      var addBtn = form.querySelector('[data-add-to-cart]');
      var select = form.querySelector('[name="id"]');
      var active;

      if (hasVariants) {
        active = getActiveVariants(root, variants, tier);
      } else if (select) {
        active = [{
          id: parseInt(select.value, 10),
          price: parseInt(root.getAttribute('data-unit-price'), 10),
          title: 'Default'
        }];
      }

      if (!active) {
        showError('Please complete all options for each item.');
        return;
      }

      addBundleToCart(form, buildCartItems(active, tier.qty, tier.pct), addBtn, tier.qty, tier.pct);
    }, true);
  }

  document.querySelectorAll('[data-valor-bundle]').forEach(initBundle);
})();
